import React from "react";
import { ComponentType, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { setDialogHandle } from "../../actions/dialog";
import { setIsDialogOpen } from "../../actions/dialog";
import { CREATE_URL } from "../../const/URL.const";
import { IReduxAppState } from "../../reducers";
import { IDialogHandleState, IDialogChildComponent } from '../../reducers/dialog';

interface IHistoryState<T extends IDialogChildComponent> extends IDialogHandleState<T> {
}

export interface IDialogRouteChildren extends IDialogChildComponent {
    isNewItem: boolean;
    venueId: string;
    id: string;
    history: any;
    dialogTitle: IRouteTitle;
}
export type IRouteTitle = string | JSX.Element | TitleTypes;
type TitleTypes = { create: string, update: string };

interface IDialogProps<T extends IDialogChildComponent> {
    Component: ComponentType<T> | null;
    ComponentPropsFunctions: any;
    navigateBackRoute: string;
    dialogTitle: IRouteTitle;
    dialogClassName?: string;
    navigateBackFunction?: () => void;
    isFormDialog?: boolean;
    onCloseIcon?: () => void;
}

/**Dialog route component
 * Handles dialogs which are part of a route component 
 */
export function DialogRoute<T extends IDialogChildComponent>(props: IDialogProps<T>) {
    const history = useHistory<IHistoryState<T>>();
    let { id } = useParams<{ id: string }>();
    const dispatch = useDispatch();
    const venueId = useSelector((state: IReduxAppState) => state.selectedVenueId);

    useEffect(() => {
        const state = history.location.state;
        /**close last opened modal */
        dispatch(setIsDialogOpen(false));
        const isNew = id === CREATE_URL;
        /**changing modal stage after making sure of closing last opened modal */
        setTimeout(() => {
            dispatch(setDialogHandle({
                ...state,
                Component: props.Component,
                ComponentProps: {
                    ...props.ComponentPropsFunctions,
                    isNewItem: isNew ? true : false,
                    venueId,
                    ...state,
                    id,
                    onClose: navigateBack,
                    history
                },
                dialogTitle: generateTitle(isNew),
                isFormDialog: props.isFormDialog !== undefined ? props.isFormDialog : true,
                styles: props.dialogClassName ? { className: props.dialogClassName } : undefined,
                isOpen: true,
                onCloseIcon: props.onCloseIcon
            }));
        }, 400);
        /**Generate different title types */
        function generateTitle(isNewItem: boolean) {
            if (state?.dialogTitle) {
                return state.dialogTitle;
            }
            if (props.dialogTitle &&
                typeof props.dialogTitle === "object") {
                /**Check if its an element */
                if (React.isValidElement(props.dialogTitle)) {
                    return props.dialogTitle;
                }
                const title = props.dialogTitle as TitleTypes;
                return title[isNewItem ? "create" : "update"];
            }
            return props.dialogTitle;
        }
        //eslint-disable-next-line
    }, [history.location.pathname]);

    function navigateBack() {
        /**Handles timeout of animation */
        setTimeout(() => {
            history.replace(props.navigateBackRoute);
            if (props.navigateBackFunction) {
                props.navigateBackFunction();
            }
        }, 300);
    }

    return <>

    </>
}